import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import img from '../../assets/card-content.png.js';
import img$1 from '../../assets/card-content@2x.png.js';
import styles from './CreditCardContentIcon.module.scss.js';

const CreditCardContentIcon = ({ className }) => {
    return (jsx("img", { className: classNames(styles.creditCardContentIcon, className), src: img, alt: "Expiration date", srcSet: `${img} 1x, ${img$1} 2x`, "data-zta": "cc-front-expiry-date" }));
};

export { CreditCardContentIcon as default };
//# sourceMappingURL=CreditCardContentIcon.js.map
